import React, { useCallback, useEffect, useState } from 'react';
import CommonTaxModal from '../common-components/CommonTaxModal';
import SelectInputField from '../common-components/SelectInputField';
import { useFormik } from 'formik';
import { Typography } from '@mui/material';
import { getTaxFilingData, getTaxFilingDataById } from '../../stores/taxfiling';
import { useAppDispatch } from '../../stores/store';

interface CopyModelProps {
  open: boolean;
  handleClose: () => void;
  taxfillingOrderList?: any[];
  onOrderSelected?: (orderId: string) => void; // Add callback for selected order
}

const CopyModel: React.FC<CopyModelProps> = ({ 
  open, 
  handleClose, 
  taxfillingOrderList = [],
  onOrderSelected 
}) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  // ✅ Use fallback empty array directly in destructuring (so it's never undefined)
  const filteredTaxFilingList = taxfillingOrderList.filter(
    (item) => item.step === 2
  );
// console.log(filteredTaxFilingList?.[0]?.id,"fff")
  



  const formik = useFormik({
    initialValues: {
      order_to_copy: '',
    },
    onSubmit: async (values) => {
      console.log('Selected order to copy:', values.order_to_copy);

      
      if (values?.order_to_copy) {
        setIsLoading(true); // Start loading
        console.log(values.order_to_copy,"values.order_to_copy")
        const payload = {
          tax_filing_file_id: values?.order_to_copy
        }
        // Call getTaxFilingList with the selected order ID
        const result = await dispatch<any>(getTaxFilingDataById(payload));
        
        // If you have the onOrderSelected callback, call it with the result
        if (onOrderSelected) {
          onOrderSelected(values.order_to_copy);
        }
        setIsLoading(false); // Stop loading
      }
      
      handleClose();
    },
  });

  return (
    <CommonTaxModal
      open={open}
      handleClose={handleClose}
      title="Copy"
      btnTitle={"Copy"}
      btnTitle2="Cancel"
      handleSubmit={formik.handleSubmit} // Add form submission
      loading={isLoading}
    >
      <SelectInputField
        formik={formik}
        placeholder="Select option"
        label="Select an order to copy form"
        // ✅ Use filtered list here, so it only shows step=2 data
        menuData={filteredTaxFilingList}
        name="order_to_copy"
        productName={true}
      />

      <Typography
        variant="body2"
        sx={{ paddingBottom: '20px', color: '#666' }}
      >
        You'll be able to review and edit your information before submitting.
      </Typography>
    </CommonTaxModal>
  );
};

export default CopyModel;
